import { Box, Grid, Typography, styled } from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";
import OrderCancelButton from "pages/History/TradeHistory/Components/OrderCancelButton";
import { TRADE_SIDE } from "../../constants";

function HistoryBox({ item, onCancel, hasCancel = false }) {
  return (
    <HistoryBoxWrapper side={item?.sideId}>
      <Grid container>
        <Grid item xs={6}>
          <Typography
            color={
              item?.sideId === TRADE_SIDE.Buy.id ? "success.main" : "error"
            }
            variant="subtitle1"
          >
            {item?.side} {item?.walletType} {item?.type}
          </Typography>

          <CoinWrapper>
            <img src={DefaultUrlWeb + item?.coinSourceImageUrl} alt="" />

            <Box>
              <Typography color="text.main" variant="h6" component="span">
                {item?.coinSourceName}{" "}
              </Typography>
              <Typography
                color="text.main"
                variant="subtitle1"
                component="small"
              >
                / {item?.coinDestinationName}
              </Typography>
            </Box>
          </CoinWrapper>
        </Grid>

        <Grid item xs={6}>
          <Typography
            color="text.secondary"
            variant="subtitle2"
            textAlign="right"
          >
            {item?.date}
          </Typography>
          <Typography
            color="text.secondary"
            variant="subtitle2"
            textAlign="right"
          >
            {item?.time}
          </Typography>
        </Grid>
      </Grid>

      <Grid container mt={1} spacing={1}>
        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Username
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.main"
              fontWeight={400}
            >
              {item?.userRegister}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Broker
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.broker}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Basket
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.basketOwner}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Amount
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.filled || 0} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinSourceName}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Price
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.price} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinDestinationName}
            </Typography>
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            Total
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <NumberFormats value={item?.total} />{" "}
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.coinDestinationName}
            </Typography>
          </Typography>
        </Grid>

        {item?.fee ? (
          <Grid item xs={6}>
            <Typography color="text.secondary" variant="subtitle2">
              Fee
            </Typography>

            <Typography color="text.main" fontWeight={500} variant="h6">
              <NumberFormats value={item?.fee} />{" "}
              <Typography
                component="span"
                variant="subtitle2"
                color="text.secondary"
                fontWeight={400}
              >
                {item?.coinFeeName}
              </Typography>
            </Typography>
          </Grid>
        ) : (
          ""
        )}

        <Grid item xs={6}>
          <Typography color="text.secondary" variant="subtitle2">
            State
          </Typography>

          <Typography color="text.main" fontWeight={500} variant="h6">
            <Typography
              component="span"
              variant="subtitle2"
              color="text.secondary"
              fontWeight={400}
            >
              {item?.state}
            </Typography>
          </Typography>
        </Grid>

        {hasCancel && (
          <Grid item xs={6} textAlign="right">
            <OrderCancelButton
              justifyContent="flex-end"
              alignItems="flex-end"
              onClick={onCancel}
              item={item}
            />
          </Grid>
        )}
      </Grid>
    </HistoryBoxWrapper>
  );
}

const HistoryBoxWrapper = styled(Box)(({ side, theme }) => ({
  background:
    side === TRADE_SIDE.Buy.id
      ? theme.palette.background.successGradient
      : theme.palette.background.errorGradient,

  border: `1px solid ${side === TRADE_SIDE.Buy.id
    ? theme.palette.success.main
    : theme.palette.error.main
    }30
  `,

  borderRadius: "8px",
  padding: theme.spacing(1),
}));

const CoinWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",

  img: {
    marginRight: theme.spacing(1),
    width: "27px",
    height: "27px",
  },
}));

export default HistoryBox;
